import React from 'react';
import SectorPulse from "../../components/intraday/SectorPulse";
import LiveSectorMomentum from "../../components/intraday/LiveSectorMomentum";
import { Typography } from "antd";
import { useIsMobile } from "../../hooks/use-mobile";
import { cn } from "../../lib/utils";

const { Text } = Typography;

const Intraday = () => {
  const isMobile = useIsMobile();

  return (
    <main className="pt-10 pb-20 bg-darkMode-background">
      <div className="flex items-center gap-1 mx-6 md:px-0">
        <div>
          <h1 className="text-4xl md:text-5xl font-bold mb-2">
            Sector <span className="text-market-teal">Momentum</span>
          </h1>
          <Text className="text-sm text-darkMode-subText px-4 md:px-0">
            Real-time sector analysis and market momentum tracking for intraday traders.
          </Text>
        </div>
      </div>

      <section className="container mx-auto px-4 max-w-6xl">
        <div className="space-y-8 mt-8">
          <SectorPulse />
          <LiveSectorMomentum />
        </div>
      </section>
    </main>
  );
};

export default Intraday;
